/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,updateCategory,setQuote,initQuote,uploadProducts, setOpenConfirmEditModal, setLoading, setCompanyLoaded} from '../actions/quote'
import Category from "./Category.js"
import { toast } from 'react-toastify';
import { Badge } from "reactstrap";
import OrderHeader from "./IndexSections/OrderHeader.js";
import { getDateTime } from "../common"

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import Memo from "./IndexSections/Memo"
import { Editor } from '@tinymce/tinymce-react';


import Product from "./IndexSections/Product.js";
import TabsClient from "./Orderspart/TabsClient";


function Index(props) {
  const main = useRef();
  const [noteModal, setNoteModal] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [memoNote, setMemoNote] = useState("");
  const [openOrderRequested, setOpenOrderRequested] = useState(false);
  const [newMemoNote, setNewMemoNote] = useState("");
  const [memos, setMemos] = useState([]);
  
  const toggleNote = () => setNoteModal(!noteModal);

  const user = localStorage.getItem('user_bigbrand');
  var userinfo;
  var role = ""
  if(user && user != undefined){
    userinfo = JSON.parse(user)
    role = userinfo['role']
  }

  useEffect(() => {
    props.initQuote()
    let { id } = props.match.params
    axios.get(`/quotes/edit/${id}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        var quote = res.data.data
        if(quote && quote.content){
          var categories = JSON.parse(quote.content);
          for(var key in categories){
            var category = {...categories[key]};
            var items = category['items']
            var groups = category['groups']
            for(var loop = 0; loop < items.length; loop++){
              if(groups){
                var group = groups[loop]
                if("fee_price" in group){
                  group['fee_price'] = (group['fee_price']*1).toFixed(2)
                }
                else{
                  group['fee_price'] = (0).toFixed(2)
                }
                if("price" in group){
                  group['price'] = (group['price']*1).toFixed(2)
                }
                else{
                  group['price'] = (0).toFixed(2)
                }
                if("discount_price" in group){
                  group['discount_price'] = (group['discount_price']*1).toFixed(2)
                }
                else{
                  group['discount_price'] = (0).toFixed(2)
                }
                group.cost_visible = false
                items[loop]['group_options'] = group  
              }     
            }
            category['items'] = items;
            categories[key] = category;
          }
          setMemoNote(quote.memo_note)
                    
          var init_quote = {
            user_id: quote.user_id?quote.user_id:null,   
            categories: categories,
            selectedContactUser: quote.contact_user?quote.contact_user:null,            
            selectedContactAddress: quote.contact_address?quote.contact_address:null,
            selectedContactInfo: quote.contact_info?quote.contact_info:null,
            validDate: quote.valid_to?quote.valid_to:null,
            delivery_required: quote.delivery_required?quote.delivery_required:null,
            pickup_instore: quote.pickup_instore?quote.pickup_instore:null,
            collection_id: quote.collection_id?quote.collection_id:null,
            id: quote.id?quote.id:null,
            revision: quote.revision?quote.revision:null,
            memo_note: quote.memo_note,
            totalPrice: quote.price,
            gst: quote.gst,
            status: quote.status,
            order_status: quote.order_status,
            quoteLabel: quote.label,
            clientLabel: quote.client_label,
            defaultBrand: quote.default_brand,
            created_at: quote.created_at,
            wfm_order_no: quote.wfm_order_no
          };
          props.setQuote(init_quote)

        }
        else{          
          var init_quote = {
            id:quote.id,
            user_id: quote.user_id?quote.user_id:null,   
            categories: {},
            memo_note: ''
          };
          props.setQuote(init_quote)
        }        
    }) 
    setOrderId(id) 
  },[]);

  
  useEffect(() => {
    if(props.quote.companyLoaded){
      if(!props.quote.productUploaded)
        props.uploadProducts();
      getmemo()
    }
  },[props.quote.companyLoaded]);

  const editConfirm = ()=>{
    const {
      selectedContactUser,
      selectedContactAddress,
      selectedContactInfo,
      custom_address,
      logoImage,
      validDate,
      pickup_instore,
      delivery_required,
      collection_id
    } = props.quote;

    if(!delivery_required && !pickup_instore){
      toast.error('You must select a delivery preference. Please try again');
      return;
    }
    if((delivery_required || pickup_instore) && !collection_id){
      toast.error('You must select a collection contact. Please try again');
      return;
    }
    var quote = props.quote;
    var bodyFormData = new FormData();
    
    bodyFormData.append('status', "Pending Quote");
    props.setLoading(true)
    axios.post(`/quotes/setstatus/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){   
        window.location.reload();
      }
      else{
        toast.error(result.data?result.data:"Something was wrong. Try again");
      }
      props.setLoading(false)
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const renderCategory=()=>{
    const quote = props.quote;
    const categories = quote.categories;
    var elements = [];
    if(categories[0]){
      const category = categories[0]
      elements.push(
        <Category history={props.history} category={category.category_info} state={category.items} groups={category.groups} updateCategory={props.updateCategory} submitOrder={submitOrder}/>
      )
    }
    else{
      elements.push(
        <Category history={props.history} category={null} state={[]} groups={[]} updateCategory={props.updateCategory} submitOrder={submitOrder}/>
      )
    }
    return elements;
  }
  const submitOrder=async(e, op)=>{
    const {
      selectedContactUser,
      selectedContactAddress,
      selectedContactInfo,
      custom_address,
      logoImage,
      validDate,
      pickup_instore,
      delivery_required,
      collection_id
    } = props.quote;
    var quote = props.quote;
    var bodyFormData = new FormData();
    var categories = {...quote.categories};
    for(var key in categories){
      var category = {...categories[key]};
      var items = category['items']
      var groups = [];
      for(var loop = 0; loop < items.length; loop++){
        var groupOptions = items[loop]['group_options'];
        groups.push(groupOptions?groupOptions:{});
      }
      category['groups'] = groups;
      categories[key] = category;
    }
    bodyFormData.append('content', JSON.stringify(categories));
    bodyFormData.append('contact_user',selectedContactUser?selectedContactUser:'')
    bodyFormData.append('contact_address',selectedContactAddress?selectedContactAddress:'')
    bodyFormData.append('contact_info',selectedContactInfo?selectedContactInfo:'')
    bodyFormData.append('custom_address',custom_address?custom_address:'')
    bodyFormData.append('valid_to',validDate?validDate:"")
    bodyFormData.append('pickup_instore',pickup_instore?"1":"0")
    bodyFormData.append('collection_id',collection_id?collection_id:'')
    bodyFormData.append('delivery_required',delivery_required?"1":"0")
    bodyFormData.append('updated_at',getDateTime())
    bodyFormData.append('label',quote.quoteLabel?quote.quoteLabel:"")
    bodyFormData.append('client_label',quote.clientLabel?quote.clientLabel:"")
    bodyFormData.append('price',quote.totalPrice?quote.totalPrice:"")    
    bodyFormData.append('gst',quote.gst?quote.gst:"") 
    bodyFormData.append('default_brand',quote.defaultBrand?quote.defaultBrand:"") 
    bodyFormData.append('wfm_order_no',quote.wfm_order_no?quote.wfm_order_no:"") 

    // if not selected contact user skip - mykhailo 2025.09.18
    if(!selectedContactUser){
      toast.error('You must select the contact user. Please try again');
      return;
    }
    if(!delivery_required && !pickup_instore){
      toast.error('You must select a delivery preference. Please try again');
      return;
    }
    if((delivery_required || pickup_instore) && !collection_id){
      toast.error('You must select a collection contact. Please try again');
      return;
    }
    
    var status;
    var order_status;
    var successMsg = "success"
    if(op == "save"){
      successMsg = "Your changes have been saved"
    }
    else if(op == "request_quote"){
      status = "Pending Quote"
      successMsg = "Your quote has been requested"
    }
    else if(op == "decline_quote"){
      status = "Declined Quote"
      successMsg = "Your quote has been declined"
    }
    else if(op == "revise"){
      successMsg = "Your quote has been revised"
    }
    else if(op == "request_order"){
      order_status = "Requested Order"
      successMsg = "Your order has been requested"
      setOpenOrderRequested(true); return;
    }

    if(status)
      bodyFormData.append('status', status);
    if(order_status)
      bodyFormData.append('order_status', order_status);
    if(logoImage)
      bodyFormData.append('logo', logoImage);
    props.setLoading(true);
    axios.post(`/quotes/edit/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){   
        if(op == "request_order"){
          setOpenOrderRequested(true); return;
        }
        else{
          toast.success(successMsg);
        }
        props.setLoading(false);
        if(op != 'save' && op != 'save_order')
          props.history.push("/myorders")
      }
      else{
        props.setLoading(false);
        toast.error(result.data?result.data:"Something was wrong. Try again");
      }
    }).catch(err => {
      props.setLoading(false);
      toast.error('Something was wrong. Try again');
    })
  }
  
  const repeatOrder=async()=>{
    var quote = props.quote;
    var bodyFormData = new FormData();    
    axios.post(`/quotes/repeat/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your quote has been copied");
        props.history.push("/myorders")
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }
  
  const addMemo =async()=>{
    let userId = props.quote.user_id

    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('memo_note', newMemoNote);
      bodyFormData.append('user_to', userId);
      if(props.quote){
        axios.post(`/quotes/addcompanymemo`, bodyFormData).then(res => {
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }

  const uploadfile =async(e)=>{
    let userId = props.quote.user_id

    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('user_to', userId);
      bodyFormData.append('file', e.target.files[0]); 
      if(props.quote){
        axios.post(`/quotes/uploadmemofile`, bodyFormData).then(res => {
          console.log("UPLOAD FROM: EditQuote.js");
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }
  
  const getMemoCount = (memo)=>{
    if(!memo) return 0
    const  newstrings = memo.split("\n"); 
    return newstrings.length;
  }
  const getmemo=()=>{
    let userId = props.quote.user_id

    if(userId) {
      axios.get(`/quotes/getcompanymemo/${userId}`).then(res => {
        if(res.data.status == "success"){
          setMemos(res.data.data)
        }
      }) 
    }
  }
  const removememo = (id)=>{
    axios.get(`/quotes/removememo/${id}`).then(res => {
      if(res.data.status == "success"){
        getmemo()
      }
    }) 
  }
  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row className="mt-6">
            <Col  md="12">
              <TabsClient history={props.history}/>
              <div style={{marginTop:10}}>
                <OrderHeader/>
                </div>
              {
                renderCategory()
              }
              {/* <div style={{marginTop:'60px'}}>
                <div className="order-nav">
                  <div>
                  </div>
                  <div>
                    <Button
                      onClick={()=>setNoteModal(true)}
                      className="btn-icon btn-3 rounded-0" color="primary" type="button">
                      <i style={{fontSize:20}} className="fa fa-commenting-o" aria-hidden="true"></i>
                      <Badge className="badge-white m-0">{getMemoCount(memoNote)}</Badge>
                    </Button>
                    <Button
                      onClick={(e)=>submitOrder(e, null)}
                      color="primary" outline
                      className="btn-icon btn-3 rounded-0 border-3" type="button">
                      <span className="btn-inner--text"><b>SAVE DRAFT</b></span>
                    </Button>
                    <Button
                      onClick={(e)=>submitOrder(e,"Requested")}
                      className="btn-icon btn-3 rounded-0 border-3" outline color="primary" type="button">
                      <span className="btn-inner--text"><b>SUBMIT</b></span>
                    </Button>
                    <Button
                      onClick={(e)=>submitOrder(e,"Approved")}
                      className="btn-icon btn-3 rounded-0 border-3" outline color="primary" type="button">
                      <span className="btn-inner--text"><b>Approve</b></span>
                    </Button>
                  </div>
                </div>                
              </div> */}
            </Col>
          </Row>
          <Modal className="modal-lg conversation-log" isOpen={noteModal} toggle={toggleNote} size="lg">
            <ModalHeader toggle={toggleNote}>
              <h3 className="h4 font-weight-bold mb-0">
              Conversation Log
              </h3>
            </ModalHeader>
            <ModalBody>
                  <FormGroup>
                    <Memo memos = {memos} removememo = {removememo}/>
                  </FormGroup>
                  <FormGroup>
                  {/* <Input type="input" rows="" value={newMemoNote} onChange={(e)=>setNewMemoNote(e.target.value)} placeholder="Type here..."/> */}
                  <Editor
                    initialValue={''}
                    apiKey='tjdmpms7zl95nzbouj8gcxhkk9q122xd7fsce8wjk0hqwn8g'
                    init={{
                      plugins: 'link image code',
                      toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
                      content_style: "p { margin: 0 0 3px 0; }",
                    }}
                    onChange={(e)=>setNewMemoNote(e.target.getContent())}
                  />
                  
                  </FormGroup>
                  <div style={{display:'flex', justifyContent:'flex-end', padding:"0 20px"}}>
                    <Button className="" onClick={()=>{document.getElementById(`upload-file`).click();}}  color="primary" type="button">
                      Upload File
                    </Button>
                    <Button color="primary" onClick={()=>addMemo()}>Add</Button>{' '}
                    <Button color="secondary" onClick={toggleNote}>Close</Button>
                  </div>
                  <input type="file" id={`upload-file`} style={{display:'none'}} onChange={(e)=>uploadfile(e)}/>
            </ModalBody>            
          </Modal>
          <Modal isOpen={props.quote.openConfirmEditModal} toggle={()=>props.setOpenConfirmEditModal(false)} >
            <ModalHeader toggle={()=>props.setOpenConfirmEditModal(false)}>Confirm</ModalHeader>
            <ModalBody>
              You are about to make a change to this quote, this will need to be resubmitted as a new quote request, are you sure you want to continue??
            </ModalBody>
            <ModalFooter>
              <Button color="primary" size="sm" onClick={()=>{editConfirm(false)}}>Yes</Button>{' '}
              <Button color="secondary" size="sm" onClick={()=>props.setOpenConfirmEditModal(false)}>No</Button>
            </ModalFooter>
          </Modal>
          
          <Modal isOpen={openOrderRequested} toggle={()=>setOpenOrderRequested(false)} >
            <ModalHeader toggle={()=>setOpenOrderRequested(false)}>Note</ModalHeader>
            <ModalBody>
              Your Order has been submitted and we will send you updates as the order progresses.
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" size="sm" onClick={()=>setOpenOrderRequested(false)}>Close</Button>
            </ModalFooter>
          </Modal>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    uploadProducts: ()=>dispatch(uploadProducts()),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
    setOpenConfirmEditModal: data=>dispatch(setOpenConfirmEditModal(data)),
    setLoading:  data=>dispatch(setLoading(data)),
    setCompanyLoaded: value=>dispatch(setCompanyLoaded(value)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
